var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsUnread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_3544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_3544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 22C11.9422 22 11.4714 21.8042 11.0797 21.4125C10.688 21.0208 10.4922 20.55 10.4922 20H14.4922C14.4922 20.55 14.2964 21.0208 13.9047 21.4125C13.513 21.8042 13.0422 22 12.4922 22ZM4.49219 19V17H6.49219V10C6.49219 8.61667 6.90885 7.3875 7.74219 6.3125C8.57552 5.2375 9.65885 4.53333 10.9922 4.2V3.5C10.9922 3.08333 11.138 2.72917 11.4297 2.4375C11.7214 2.14583 12.0755 2 12.4922 2C12.9089 2 13.263 2.14583 13.5547 2.4375C13.8464 2.72917 13.9922 3.08333 13.9922 3.5V3.825C13.8089 4.19167 13.6755 4.56667 13.5922 4.95C13.5089 5.33333 13.4755 5.725 13.4922 6.125C13.3255 6.09167 13.163 6.0625 13.0047 6.0375C12.8464 6.0125 12.6755 6 12.4922 6C11.3922 6 10.4505 6.39167 9.66719 7.175C8.88385 7.95833 8.49219 8.9 8.49219 10V17H16.4922V10.575C16.7922 10.7083 17.113 10.8125 17.4547 10.8875C17.7964 10.9625 18.1422 11 18.4922 11V17H20.4922V19H4.49219ZM18.4922 9C17.6589 9 16.9505 8.70833 16.3672 8.125C15.7839 7.54167 15.4922 6.83333 15.4922 6C15.4922 5.16667 15.7839 4.45833 16.3672 3.875C16.9505 3.29167 17.6589 3 18.4922 3C19.3255 3 20.0339 3.29167 20.6172 3.875C21.2005 4.45833 21.4922 5.16667 21.4922 6C21.4922 6.83333 21.2005 7.54167 20.6172 8.125C20.0339 8.70833 19.3255 9 18.4922 9Z",
    fill: "#F6F8F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsUnread);
export default __webpack_public_path__ + "static/media/notifications_unread.436d80ceca7f66b8d8d4dea9cb3608d9.svg";
export { ForwardRef as ReactComponent };